module.exports = "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>";